module.exports = __webpack_public_path__ + "static/media/1.be10fbeb.svg";